import _ from 'lodash'
import Vue from 'vue'
import apolloProvider from '@/plugins/vue-apollo'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/vue-i18n'
import Notification from '@/services/notification'
import store from './store'
import router from './router'
import App from './App.vue'
import '@/plugins/lodash'
import '@/plugins/dayjs'
import '@/plugins/queue'
import '@/plugins/vue-infinite-loading'
import '@/plugins/vue-upload-component'
import * as components from './components'
import * as filters from './filters'

_.forEach(components, (value, key) => {
  Vue.component(_.kebabCase(key), value.default)
})
_.forEach(filters, (value, key) => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'snt-navbar'
]
Vue.prototype.$notify = new Notification()

const createApp = () => new Vue({
  router,
  store,
  apolloProvider,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app')

createApp()
